export default {
  guide: {
    steps: {
      findPlan: {
        title: "Find the right plan",
        description: "Tell us what you need and we'll recommend the L'Authorize setup that best fits your business.",
        placeholder: "Find the right plan content will be connected in the next phase.",
      },
      products: {
        title: "Add your products or packages",
        description: "Add the products or packages you want to manage with L'Authorize.",
        placeholder: "Products or packages content will be connected in the next phase.",
      },
      ar: {
        title: "Authorized Representative",
        description: "Choose whether you need Lappa to act as your Authorized Representative.",
        placeholder: "Authorized Representative content will be connected in the next phase.",
      },
      docs: {
        title: "Document verification",
        description: "Required only if you appoint Lappa as your Authorized Representative.",
        placeholder: "This step becomes available when you appoint Lappa as your Authorized Representative.",
      },
      mandate: {
        title: "Sign your mandate",
        placeholder: "You'll be able to sign your mandate after appointing Lappa and completing the required verification.",
      },
      firstLabel: {
        title: "Create your first digital label",
        description: "Your setup is ready. Choose a product or package from your list to create your first digital compliance label.",
      },
    },
    summary: {
      withLappa: "With Lappa",
      completed: "Completed",
      needAction: "Need your action",
      upcoming: "Upcoming",
      title: "Setup summary",
      needHelp: "Need help?",
      questions: "Have questions about your setup?",
      contactSupport: "Contact support",
    },
    onboarding: {
      change: "Change",
      title: "Welcome to L'Authorize!",
      subtitle: "Let's get your account ready. We'll guide you through each step.",
      stepsAria: "L'Authorize setup steps",
      skipped: {
        ar: "You chose not to use Lappa as your Authorized Representative.",
        docs: "No document verification is needed because you don't use Lappa as your Authorized Representative.",
        mandate: "Not required – you haven't appointed Lappa as your Authorized Representative.",
      },
      yes: {
        ar: "Appoint Lappa as your Authorized Representative if you need representation services.",
        docs: "We'll review your company information and submitted documents.",
        mandate: "Available after your documents are verified.",
      },
      submitted: {
        ar: "Lappa has been appointed and your required documents have been submitted.",
        docs: "We're reviewing the documents you submitted for your Authorized Representative setup.",
      },
      stepsRemaining_one: "{{count}} step remaining",
      stepsRemaining_other: "{{count}} steps remaining",
    },
    ar: {
      yesLabel: "Yes, appoint Lappa",
      yesSublabel: "I want Lappa to act as my Authorized Representative.",
      noLabel: "No, I don't need an Authorized Representative",
      noSublabel: "I don't need representation services from Lappa.",
      docs: {
        tradeRegister: "Trade register extract",
        vatNumber: "VAT number",
        directorPassport: "Director Passport",
        bankStatement: "Bank Statement",
      },
      submittedTitle: "Submitted documents",
      submittedText: "The following documents have been submitted for review.",
      submittedNote: "Your documents have been submitted to Lappa for review.",
      question: "Do you want to appoint Lappa as your Authorized Representative?",
      intro: "If you appoint Lappa, we'll need some company information and KYC documents before representation can begin.",
      docsTitle: "Documents you'll need",
      docsText: "To complete the setup, you'll be asked to provide the following documents:",
      uploadDocuments: "Upload documents",
    },
    firstLabel: {
      next: {
        choose: "Choose a product or package from your list",
        create: "Create the appropriate digital label from its available actions",
        complete: "Complete the label information and publish it when ready",
      },
      goodToKnow: {
        more: "You can create labels for additional products or packages at any time",
      },
      goToProducts: "Go to products & packages",
      whatToDo: "What do I need to do?",
      whatHappensNext: "What happens next",
    },
    common: {
      goodToKnow: "Good to know",
    },
    products: {
      requirements: {
        atLeastOne: "Add at least one product or package",
        complete: "Complete the required information for the item you add",
      },
      goodToKnow: {
        more: "You can add more products or packages at any time",
        later: "Additional details can be added or updated later",
      },
      addProduct: "Add product",
      addPackage: "Add package",
      whatToComplete: "What do I need to complete?",
      requirementsTitle: "Requirements",
    },
    docs: {
      underReview: "Documents under review",
      noAction: "No action is needed from you right now.",
    },
    showOnHome: "Show on the home page",
    plan: {
      yourAnswers: "Your answers",
      savedPreferences: "We've saved your preferences below. Plan recommendation will be available once business rules are confirmed.",
      summary: {
        products: "Products",
        labels: "Digital compliance labels",
        markets: "Markets",
      },
      compareAll: "Compare all plans",
      changeAnswers: "Change my answers",
      introTitle: "Let's find the right setup for you",
      introText: "Answer a few quick questions. We'll use your answers to recommend a plan that fits your needs.",
      q: {
        products: "How many products do you expect to manage?",
        productsHint: "This helps us match your expected usage with the right plan.",
        labels: "Will you need digital compliance labels?",
        labelsHint: "For example, digital labels for product or packaging compliance.",
        labelCount: "Approximately how many labels will you need?",
        labelCountPlaceholder: "e.g. 25",
        markets: "Where do you sell or plan to sell your products?",
        marketsHint: "Choose the markets you want to cover with L'Authorize.",
        ar: "Do you need Lappa to act as your Authorized Representative?",
        arHint: "You can change this preference later.",
      },
      seeRecommendation: "See my recommendation",
      options: {
        moreThan50: "More than 50",
        yes: "Yes",
        no: "No",
        notSureYet: "Not sure yet",
        both: "Both",
        imNotSure: "I'm not sure",
      },
      yesApprox: "Yes · approx. {{count}}",
    },
  },
};
